import React from 'react';
import {connect} from "react-redux";
import {setSelectedPartIds} from "../../../../../../../../actions/sqftResourceFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import FeatureThumbnail from "../../../../../../../visComponents/featureThumbnail";
import {getFeatureGroupName} from "../../../../../../../../misc/helpers";
import {getCurrentLayout} from "../../../../../../../appLayout";
import {CABINET_PART_IDS_THAT_CAN_HAVE_HANDLES, SHAPE_PART_ID} from "../../../../../../constants";

const SqftOptionsHandlesContent = (props) => {
  const {selectedPartIds, setSelectedPartIds, selectedHandle, intl, fabricatorData} = props;

  const toggleCabinetsApplyTo = (togglePartId) => {
    let newList = [...selectedPartIds];
    newList.includes(togglePartId)
      ? newList = newList.filter(partId => partId !== togglePartId)
      : newList.push(togglePartId);
    setSelectedPartIds(newList);
  };

  const getButtonName = (partId, layout) => {
    //if (intl.locale !== "en-EN") {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup) {
        return getFeatureGroupName(featureGroup, intl, fabricatorData).replace(' Color', '')
      }
    //}
    switch (partId) {
      case "top_cabinet":
      case SHAPE_PART_ID.upper_cabinet_boxes:
        return "Upper cabinet";
      case SHAPE_PART_ID.lower_cabinet_boxes:
      case "bottom_cabinet":
        return "Lower cabinet";
      case "center_island_cabinet":
        return "Center island";
      case "vanity_cabinet":
        return "Cabinet";
      case "vanity_mirror":
        return "Mirror";
      default:
        return ""
    }
  };
  const layout = getCurrentLayout();

  return (
    <div className={"bootstrap-wrapper"}>
      <div className={"container-fluid"}>
        <div className={"row"}>
          <div className={"col-6 message-window-container_fluid"}>
            <FeatureThumbnail feature={selectedHandle}/>
            <div>
              <FormattedMessage id="sqft.popup.title.selectedHandle"/> {selectedHandle.getFeatureName()}
            </div>
          </div>
          <div className={"col-6 message-window-container_fluid"}>
            {CABINET_PART_IDS_THAT_CAN_HAVE_HANDLES.map( allowedPartId => {
              const buttonName = getButtonName(allowedPartId, layout);
              if (buttonName) {
                const disabledButton = false;
                const checked = selectedPartIds.includes(allowedPartId);
                return (
                  <div key={"dropdownRelated"+allowedPartId}
                       className={"ui-select__dropdown-list-item"}>
                  <span className={"ui-checkbox ui-checkbox--small"
                  + (!disabledButton && checked? " ui-checkbox--checked" : "")
                  + (disabledButton ? " ui-checkbox--disabled" : "")}
                        onClick={() => disabledButton ? false : toggleCabinetsApplyTo(allowedPartId)}/>
                    <span className={"ui-checkbox__label" + (disabledButton ? " ui-checkbox__label--disabled" : "")}
                          onClick={() => disabledButton ? false : toggleCabinetsApplyTo(allowedPartId)}>
                    {buttonName}
                  </span>
                  </div>
                )
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {selectedHandle, selectedPartIds} = store.sqftResourceState;
  return {
    menuOpened,
    selectedHandle,
    selectedPartIds,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setSelectedPartIds
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftOptionsHandlesContent)
);
